/**
 * @generated SignedSource<<46ee1edb95ab57d856133201442bf511>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedUrgency_item$data = {
  readonly urgencyInfo: {
    readonly message: string | null;
  } | null;
  readonly " $fragmentType": "PdpSharedUrgency_item";
};
export type PdpSharedUrgency_item$key = {
  readonly " $data"?: PdpSharedUrgency_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUrgency_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedUrgency_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "UrgencyInfoType",
      "kind": "LinkedField",
      "name": "urgencyInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6fb62ea592745abc8fbe05d94550ca47";

export default node;
